// Sidebar tree row geometry — indentation/inset math shared by FolderItem and
// the drag overlay in OrganizedTableList. Kept out of the component files so
// they only export components (react-refresh requirement).

const FOLDER_ROW_PADDING_LEFT = 8
const FOLDER_CHEVRON_CENTER_OFFSET = 5
const FOLDER_CHEVRON_SIZE = 10
const FOLDER_ICON_SIZE = 14
const GUIDE_TO_ROW_GAP = 8
const FOLDER_CHEVRON_ICON_GAP =
  FOLDER_CHEVRON_CENTER_OFFSET + GUIDE_TO_ROW_GAP * 2 - FOLDER_CHEVRON_SIZE
const FOLDER_ICON_LABEL_GAP = 8
const FOLDER_LABEL_OFFSET =
  FOLDER_CHEVRON_SIZE + FOLDER_CHEVRON_ICON_GAP + FOLDER_ICON_SIZE + FOLDER_ICON_LABEL_GAP

export {
  FOLDER_ROW_PADDING_LEFT,
  FOLDER_CHEVRON_SIZE,
  FOLDER_ICON_SIZE,
  FOLDER_CHEVRON_ICON_GAP,
  FOLDER_ICON_LABEL_GAP,
}

export function getFolderGuideLeft(depth: number): number {
  return getFolderRowInset(depth) + getFolderRowPaddingLeft(depth) + FOLDER_CHEVRON_CENTER_OFFSET
}

export function getFolderRowInset(depth: number): number {
  if (depth <= 0) return 0
  return getChildRowInset(depth - 1)
}

export function getFolderRowPaddingLeft(depth: number): number {
  if (depth <= 0) return FOLDER_ROW_PADDING_LEFT
  return (
    getFolderLabelLeft(depth - 1) -
    getFolderRowInset(depth) -
    FOLDER_CHEVRON_SIZE -
    FOLDER_CHEVRON_ICON_GAP
  )
}

export function getFolderLabelLeft(depth: number): number {
  return getFolderRowInset(depth) + getFolderRowPaddingLeft(depth) + FOLDER_LABEL_OFFSET
}

export function getChildRowInset(parentFolderDepth: number): number {
  return getFolderGuideLeft(parentFolderDepth) + GUIDE_TO_ROW_GAP
}

export const ROOT_TABLE_LABEL_LEFT = getFolderLabelLeft(0)
export const ROOT_FLAT_TABLE_LABEL_LEFT =
  FOLDER_ROW_PADDING_LEFT + FOLDER_ICON_SIZE + FOLDER_ICON_LABEL_GAP
